import { instagram } from "../variables";

export default () => {
  $(".p-detail-info").prependTo(".p-detail-inner .p-info-wrapper");
  $(".p-detail-inner .p-detail-inner-header").prependTo(
    ".p-detail-inner .p-info-wrapper"
  );

  $(".benefitBanner__item:eq(0)").appendTo(".p-info-wrapper");

  $("#productsAlternative")
    .removeClass("fade")
    .insertAfter(".shp-tabs-wrapper.p-detail-tabs-wrapper");

  $(
    '<h2 class="products-similar-header new-header">Podobné produkty</h2>'
  ).insertAfter(".shp-tabs-wrapper.p-detail-tabs-wrapper");
  $(".products.products-block.products-related").insertAfter(
    ".shp-tabs-wrapper.p-detail-tabs-wrapper"
  );
  $(".products-related-header")
    .addClass("new-header")
    .insertAfter(".shp-tabs-wrapper.p-detail-tabs-wrapper");
};
